//////////////////////////////////////////////////////// 算每月上新日期+同步到说明 ////////////////////////////////////////////////////////

// ---- Waggy Waggy: restock badge localizer (v4 multilingual) ----
// If the incoming restock date is already in the past (e.g., still Jan 1 after Jan 3 sold out),
// we force the display to the 1st of NEXT month (local time).

function wwParseRestockTime(raw) {
  if (!raw) return null;

  // date-only: "YYYY-MM-DD" -> local midnight
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const parts = raw.split("-").map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  const dt = new Date(raw);
  return isNaN(dt.getTime()) ? null : dt;
}

function wwStartOfTodayLocal() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

function wwFirstDayOfNextMonthLocal() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0);
}

function wwMaybeFallbackToNextMonth(dateObj) {
  const todayStart = wwStartOfTodayLocal();
  if (dateObj < todayStart) return wwFirstDayOfNextMonthLocal();
  return dateObj;
}

function wwGetLocale() {
  return (
    document.documentElement.getAttribute("lang") ||
    document.documentElement.lang ||
    "en"
  ).replace("_", "-");
}

function wwGetAvailableLabel() {
  const el = document.getElementById("ww-i18n");
  if (el && el.dataset.availableLabel) return el.dataset.availableLabel;
  return "Available";
}

function wwRenderRestockBadges() {
  const locale = wwGetLocale();
  const availableLabel = wwGetAvailableLabel();

  // ---- Date only badge ----
  document.querySelectorAll(".convert-to-local-date-only").forEach((el) => {
    const raw = el.dataset.restockTime;
    let dateObj = wwParseRestockTime(raw);
    if (!dateObj) return;

    dateObj = wwMaybeFallbackToNextMonth(dateObj);

    const month = dateObj.toLocaleString(locale, { month: "short" });
    const day = dateObj.getDate();
    el.textContent = `${availableLabel}: ${month} ${day}`;
  });

  // ---- Date + time badge ----
  document.querySelectorAll(".convert-to-local-time").forEach((el) => {
    const raw = el.dataset.restockTime;
    let dateObj = wwParseRestockTime(raw);
    if (!dateObj) return;

    dateObj = wwMaybeFallbackToNextMonth(dateObj);

    const localTime = dateObj.toLocaleString(locale, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    });

    let timeZoneShort =
      Intl.DateTimeFormat(locale, { timeZoneName: "short" })
        .formatToParts(dateObj)
        .find((p) => p.type === "timeZoneName")?.value || "";

    if (!timeZoneShort || timeZoneShort.includes("GMT")) {
      const offset = -dateObj.getTimezoneOffset() / 60;
      timeZoneShort = offset >= 0 ? `UTC+${offset}` : `UTC${offset}`;
    }

    el.textContent = `${availableLabel}: ${localTime} ${timeZoneShort}`;
  });
}

document.addEventListener("DOMContentLoaded", wwRenderRestockBadges);

// OS2.0 themes may re-render sections dynamically
document.addEventListener("shopify:section:load", wwRenderRestockBadges);
document.addEventListener("shopify:section:select", wwRenderRestockBadges);




